import {Breakpoints, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiBreadcrumbs = ({breadcrumb, focus}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiBreadcrumbs: {
    defaultProps: {
      color: 'textPrimary'
    },
    styleOverrides: {
      root: {
        /* Styles applied to the ellipsis button element */
        '& .MuiButtonBase-root': {
          backgroundColor: 'transparent',
          marginLeft: 0,
          marginRight: 0,
          borderRadius: 0,
          borderWidth: breadcrumb?.ellipsis.desktop.border.width,
          borderStyle: breadcrumb?.ellipsis.desktop.border.style,
          borderColor: breadcrumb?.ellipsis.desktop.border.color,
          color: breadcrumb?.ellipsis.desktop.icon.color,
          height: breadcrumb?.ellipsis.desktop.height,
          width: breadcrumb?.ellipsis.desktop.width,
          paddingTop: breadcrumb?.ellipsis.desktop.padding.top,
          paddingRight: breadcrumb?.ellipsis.desktop.padding.right,
          paddingBottom: breadcrumb?.ellipsis.desktop.padding.bottom,
          paddingLeft: breadcrumb?.ellipsis.desktop.padding.left,
          '&:hover': {
            backgroundColor: breadcrumb?.ellipsis.desktop.hover.background.color,
            borderColor: breadcrumb?.ellipsis.desktop.hover.border.color,
            borderWidth: breadcrumb?.ellipsis.desktop.hover.border.width,
            borderTopRightRadius: breadcrumb?.ellipsis.desktop.border.radius.topRight,
            borderBottomRightRadius: breadcrumb?.ellipsis.desktop.border.radius.bottomRight,
            borderBottomLeftRadius: breadcrumb?.ellipsis.desktop.border.radius.bottomLeft,
            borderTopLeftRadius: breadcrumb?.ellipsis.desktop.border.radius.bottomRight,
            color: breadcrumb?.ellipsis.desktop.hover.icon.color
          },
          '&:focus, &.Mui-focusVisible': {
            backgroundColor: 'transparent',
            borderColor: focus.outline.color,
            borderWidth: focus.outline.width,
            borderStyle: focus.outline.style
          },
          /* Keyboard focus, removes the ripple */
          '&.Mui-focusVisible .MuiTouchRipple-root': {
            display: 'none'
          },
          '&:active': {
            backgroundColor: breadcrumb?.ellipsis.desktop.active.background.color,
            borderColor: breadcrumb?.ellipsis.desktop.active.border.color,
            borderWidth: breadcrumb?.ellipsis.desktop.active.border.width,
            color: breadcrumb?.ellipsis.desktop.active.icon.color
          }
        }
      },
      /* Styles applied to the current page breadcrumb?. */
      li: {
        '& a': {
          fontWeight: breadcrumb?.link.desktop.font.weight,
          [mediaQueries.down('sm')]: {
            fontSize: breadcrumb?.link.mobile.font.size,
            fontWeight: breadcrumb?.link.mobile.font.weight,
            lineHeight: breadcrumb?.link.mobile.font.lineHeight
          }
        },
        '& .currentPage': {
          color: breadcrumb?.currentpage.desktop.font.color,
          fontSize: breadcrumb?.currentpage.desktop.font.size,
          fontWeight: breadcrumb?.currentpage.desktop.font.weight,
          lineHeight: breadcrumb?.currentpage.desktop.font.lineHeight,
          [mediaQueries.down('sm')]: {
            fontSize: breadcrumb?.currentpage.mobile.font.size,
            fontWeight: breadcrumb?.currentpage.mobile.font.weight,
            lineHeight: breadcrumb?.currentpage.mobile.font.lineHeight
          }
        }
      },
      /* Styles applied to the separator element. */
      separator: {
        marginLeft: 0,
        marginRight: 0,
        color: breadcrumb?.separator.icon.desktop.color,
        height: breadcrumb?.separator.icon.desktop.height,
        width: breadcrumb?.separator.icon.desktop.width
      }
    }
  }
});
